import { httpRequest } from "@services/http";
import { JourneySummary } from "./cmdListJourneys";

export interface CreateJourneyPayload {
  name: string;
  industry: string;
}

export class CommandCreateJourney {
  async run(payload: CreateJourneyPayload): Promise<JourneySummary> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/journeys/`;
    return await httpRequest<JourneySummary>(url, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }
}
